export interface GraficoPizza {
    titulo: string;
    titulos: string[];
    valores: number[];
    media: string | null;
    total: string;
}

export const emptyGraficoPizza: GraficoPizza = {
    titulo: "",
    titulos: [],
    valores: [],
    media: null,
    total: "",
};